import React, { useContext, useEffect, useState } from "react";

import ViewTutorProfileMobile from "./ViewTutorProfileMobile/ViewTutorProfileMobile";
import { AuthContextTwo } from "../../../contexts/AuthProviderTwo";
import EditTutorProfileMobile from "./EditTutorProfileMobile/EditTutorProfileMobile";
import ProfileLoaderMobile from "../../Shared/pageLoaderGreen/ProfileLoaderMobile";

const TutorProfileMobile = () => {
  const [active, setActive] = useState("viewProfile");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleProfileView = () => {
    setActive((prevActive) =>
      prevActive === "viewProfile" ? "editProfile" : "viewProfile"
    );
  };

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const { userTwo, logOutTwo } = useContext(AuthContextTwo);

  const [imageUrl, setImageUrl] = useState(
    "https://img.freepik.com/free-photo/portrait-expressive-young-man-wearing-formal-suit_273609-6943.jpg"
  );
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state
  const [Mainloading, setMainLoading] = useState(true);
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setImageFile(file);
  };

  const updateImage = async () => {
    if (!imageFile) {
      console.error("Please select an image.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("image", imageFile);

    const imgbbApiKey = "4caaf6556f5639c7ac2506637cfd88d2";
    const imgbbUploadUrl = `https://api.imgbb.com/1/upload?key=${imgbbApiKey}`;

    try {
      const response = await fetch(imgbbUploadUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.data && data.data.url) {
        setImageUrl(data.data.url);

        // Update the image URL in the DOM
        const imageElement = document.getElementById("profileImage");
        if (imageElement) {
          imageElement.src = data.data.url;
        }

        // Update the image URL on the server
        const updateUrl = "https://tutor-tree-server-1.vercel.app/user/img";
        const updateResponse = await fetch(updateUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userTwo.email,
            img: data.data.url,
          }),
        });

        const updateData = await updateResponse.json();
        console.log("Image URL updated on the server:", updateData);
      } else {
        console.error("Failed to upload image to imgBB.");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setLoading(false); // Set loading to false after upload
      // Close the modal after upload
      handleButtonClick();
    }
  };
  const [profileData, setProfileData] = useState([]);
  const [validPercentage, setValidPercentage] = useState(0);

  const fetchData = async () => {
    const UserEmail = userTwo?.email; // Ensure this variable has the correct email value.
    const url = `https://tutor-tree-server-1.vercel.app/user/${UserEmail}`;
    console.log("url", url);
    const res = await fetch(url);
    const data = await res.json();
    setProfileData(data);
    setMainLoading(false);
    calculateValidPercentage(data);
  };

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const calculateValidPercentage = (data) => {
    // Assuming data is an array of profile objects
    if (!Array.isArray(data) || data.length === 0) {
      setValidPercentage(0);
      return;
    }

    // Fields to consider for percentage calculation
    const fields = [
      "name",
      "email",
      "phone",
      "area",
      "city",
      "emergencyNmbr",
      "gender",
      "religion",
      "HSCgroup",
      "HSCinstitute",
      "HSCresult",
      "HonsInstitute",
      "HonsMajor",
      "HonsSemester",
      "MastersInstitute",
      "MastersMejor",
      "MastersSemester",
      "SSCgroup",
      "SSCinstitute",
      "experience",
      "preArea1",
      "preArea2",
      "preCategories1",
      "preCategories2",
      "preCategories3",
      "preCategories4",
      "preClasses1",
      "preClasses2",
      "preClasses3",
      "preLocation1",
      "preSubject1",
      "preSubject2",
    ];

    let totalValidFields = 0;
    let totalFields = fields.length * data.length;

    data.forEach((profile) => {
      totalValidFields += fields.filter(
        (field) => profile[field] && profile[field].toString().trim() !== ""
      ).length;
    });

    // Calculate the overall percentage of valid fields across all profiles
    const percentage = (totalValidFields / totalFields) * 100;
    setValidPercentage(percentage);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  ///////////////////////select data ////////////////////////////

  if (Mainloading) return <div className=""><ProfileLoaderMobile></ProfileLoaderMobile></div>;

  return (
    <div className="bg-green-100 pt-2 z-40 pb-5">
       <div className="flex flex-row justify-between mb-2 border-b border-green-900  px-5">
       <h1 className="text-xl text-left py-2 font-signika text-green-900">
        Profile
      </h1>
      <button
        className="px-3 py-2 bg-green-700 my-2 text-sm rounded-lg font-montserrat modalTitle text-white"
        onClick={toggleProfileView}
      >
        {active === "viewProfile" ? "Edit Profile" : "View Profile"}
      </button>
       </div>
      <div className="w-[100%]  px-5">
        {active === "editProfile" && (
          <EditTutorProfileMobile 
          isVisible={isModalVisible}
          openModal={openModal}
          onClose={closeModal}
          handleImageUpload={handleImageUpload}
          loading={loading}
          updateImage={updateImage}
          profileData={profileData} title="1" />
        )}
        {active === "viewProfile" && (
          <ViewTutorProfileMobile profileData={profileData} title="2" />
        )}
      </div>
    </div>
  );
};

export default TutorProfileMobile;
